import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { I18n } from './core/i18n/i18n.service';
import { AuthStore } from './core/stores/auth.store';
import { LoginComponent } from './feature/login/login.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LoginComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'supplier-portal';
  i18n = inject(I18n);
  store = inject(AuthStore);

  constructor() {
    inject(I18n).addNamespace('common');
  }
}
